enum UnitOfMeasurementEnum {
    EACH = 1,
    POUNDS,
    GRAMS,
    KILOGRAMS,
    MBAG,
    BOX,
    BARREL,
    BAG,
    COIL,
    SHEET,
    LINEAR_FEET,
    OUNCES,
    MILLILITER,
    LITER,
    PIECE,
    METER,
    SQUARE_YARDS,
    SQUARE_FEET,
    GALLON,
    YARD,
    FEET,
    MBF,
    BOTTLE,
    BUNDLE,
    CAN,
    CASE,
    DOZEN,
    DRUM,
    HOUR,
    HUNDRED_WEIGHT,
    KIT,
    LOT,
    MONTH,
    PACK,
    PAIR,
    QUART,
    ROLL,
    SET,
    SKID,
    THOUSAND,
    UNIT,
    CARTON,
}

export default UnitOfMeasurementEnum;
